import { COLORS } from 'components/consts';

export const placeholderSx = {
    color: 'black',
    margin: '0',
    opacity: '0.4',
    fontSize: '12px',
    fontWeight: '500',
    fontStyle: 'italic',
} as const;

export const inputBaseSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        fontSize: '14px',
        color: COLORS.Mainblue,
        '& fieldset': { borderColor: COLORS.Mainblue },
        '&.Mui-focused fieldset': { borderColor: COLORS.Mainblue, borderWidth: '1px' },
    },
};

export const numericInputSx = {
    ...inputBaseSx,
    '& .MuiInputBase-input::placeholder': placeholderSx,
};

export const multiSelectOwnerSx = {
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px !important',
        fontSize: '14px',
        color: COLORS.Mainblue,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${COLORS.Mainblue} !important`,
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: `${COLORS.Mainblue} !important`,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: `${COLORS.Mainblue} !important`,
        borderWidth: '1px !important',
    },
    '& .MuiFormLabel-root': {
        fontSize: '12px',
        fontWeight: 600,
        color: 'black',
    },
};
